import { createContext } from "react";

export const ConnectUserToBatchContext = createContext();
